import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import { Typography, Box, TextField, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../../common/Buttons";
import { Form, Formik } from "formik";
import {
  getGuardianOridinance,
  postGuardianOridinance,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import InputField from "../../../../common/InputField";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

function Signature(props) {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    recipientPlace: "",
    grantorPlace: "",
  });

  async function fetchData() {
    props.setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getGuardianOridinance(id);
      if (result?.success) {
        setData(result?.payLoad);
        setInitialValues({
          recipientPlace: result.payLoad.recipientPlace,
          grantorPlace: result.payLoad?.grantorPlace || "",
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      props.setButtonDisabled(false);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const { recipientPlace, grantorPlace } = values;
    const payload = {
      ...data,
      recipientPlace,
      grantorPlace,
    };
    const result = await postGuardianOridinance(payload, id);
    if (result?.success) {
      props.next();
    }
    props.setButtonDisabled(false);
  };

  return (
    <>
      <Container className="summary-table documents-card-height">
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Container maxWidth="sm" sx={{ padding: "0 90px !important" }}>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {(formik) => {
                return (
                  <Form id="form_submit" onSubmit={formik.handleSubmit}>
                    <Box sx={{ mt: 5, textAlign: "center" }}>
                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="left"
                        color="color.black"
                      >
                        {t("signature-optional")}{" "}
                      </Typography>
                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="left"
                        color="#9A9A9A"
                        fontSize={"12px"}
                      >
                        {t("input-20")}
                      </Typography>

                      <InputField
                        fullWidth
                        variant="standard"
                        placeholder="Karlsruhe, 15th March 2022"
                        name="recipientPlace"
                        type="date"
                      />

                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="left"
                        color="#9A9A9A"
                        fontSize={"12px"}
                      >
                        {t("doc-tab-3")}
                      </Typography>

                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="center"
                        color="#9A9A9A"
                        fontStyle="italic"
                        fontSize={"12px"}
                      >
                        {t("please-sign")}
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        name="sign"
                        type="text"
                        sx={{
                          pointerEvents: "none",
                        }}
                      />
                    </Box>
                    <Box sx={{ mt: 5, textAlign: "center" }}>
                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="left"
                        color="color.black"
                      >
                        {t("signature-of-granter")}
                      </Typography>
                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="left"
                        color="#9A9A9A"
                        fontSize={"12px"}
                      >
                        {t("input-20")}
                      </Typography>

                      <InputField
                        fullWidth
                        variant="standard"
                        placeholder="Karlsruhe, 15th March 2022"
                        name="grantorPlace"
                        type="date"
                      />

                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="left"
                        color="#9A9A9A"
                        fontSize={"12px"}
                      >
                        {t("doc-tab-3")}
                      </Typography>

                      <Typography
                        sx={{ mt: 5 }}
                        variant="p"
                        paragraph
                        align="center"
                        color="#9A9A9A"
                        fontStyle="italic"
                        fontSize={"12px"}
                      >
                        {t("please-sign")}
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        name="sign"
                        type="text"
                        sx={{
                          pointerEvents: "none",
                        }}
                      />
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          </Container>
        )}
      </Container>
    </>
  );
}

export default Signature;
